import { render, staticRenderFns } from "./XmPreviewimg.vue?vue&type=template&id=2509eaae&scoped=true"
import script from "./XmPreviewimg.vue?vue&type=script&lang=js"
export * from "./XmPreviewimg.vue?vue&type=script&lang=js"
import style0 from "./XmPreviewimg.vue?vue&type=style&index=0&id=2509eaae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2509eaae",
  null
  
)

export default component.exports